import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Image from 'components/Image';

const PricingDetails = ({
  training,
  benefits,
  whatYouGetDetails,
  isStrikeThrough,
}) => {
  const pngStyle = {
    width: 30,
    margin: 'auto',
    verticalAlign: 'middle',
    display: 'inline-block',
  };

  return (
    <section className="black-bg">
      <div className="container">
        <div className="pricing-area">
          <h2>Pricing and Benefits</h2>
          <h3
            className={isStrikeThrough ? 'price-strike' : ''}
          >{training.country=="India"?`₹${training.fee}`:`$${training.fee}`}</h3>
          {isStrikeThrough ? (
            <div className="amazing-offer">Amazing Offer Price at Checkout</div>
          ) : null}

          {!training.enrollmentClosed ? (
            <>
              <Link to={`/checkout/${training.trainingId}`} className="white-btn">
                <span>Register now</span>
              </Link>
            </>
          ) : null}
        </div>


        <div className="what-you-get-block">
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <h2>{benefits.title}</h2>
            <div className="benefits">
              <ul>
                {benefits.list.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>
          </div>
          <div className="what-you-get-sec">
            <div className="row">
              {whatYouGetDetails.map((detail) => (
                <div className="col-md-3">
                  <div className="what-get-single">
                    <div className="what-get-img">
                      {detail.type === 'png' ? (
                        <Image src={detail.icon} alt="wheel" style={pngStyle} />
                      ) : (
                          <detail.icon />
                        )}
                    </div>
                    <h3>{detail.title}</h3>
                    {detail.description ? <p>{detail.description}</p> : null}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

PricingDetails.propTypes = {
  training: PropTypes.object,
  benefits: PropTypes.object,
  whatYouGetDetails: PropTypes.array,
  isStrikeThrough: PropTypes.bool,
};

export default PricingDetails;
